/* global axios */
import ApiClient from './ApiClient';

class RealEstateBrokerCommissionsAPI extends ApiClient {
  constructor() {
    super('real_estate_broker_commissions', { accountScoped: true });
  }

  detail(id) {
    return this.show(id);
  }

  selectPaymentMethod(id, paymentMethodId) {
    return axios.put(`${this.url}/${id}/select_payment_method`, {
      payment_method_id: paymentMethodId,
    });
  }
}

export default new RealEstateBrokerCommissionsAPI();
